exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.org-container {\n\tpadding: 10px\n}\n\n.group-container {\n\tbackground-color: white;\n\tpadding-top: 15px;\n}\n\n.box-title {\n\tfont-size: 16px;\n\theight: 35px;\n\tpadding: 5px;\n}\n\n.box-value {\n\tpadding: 5px;\n}\n\n.org-title-container {\n\tdisplay: grid;\n\twidth: 100%;\n\tgrid-template-columns: 1fr 1fr 1fr;\n\tgrid-column-gap: 5px;\n\tjustify-items: center;\n}\n\n.org-title-item:nth-child(1) {\n\tgrid-column-start: 2;\n}\n\n.org-title-item:nth-child(2) {\n\tmargin-left: auto;\n}\n", ""]);

// exports
